import script from "./LoadingBar.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingBar.vue?vue&type=script&setup=true&lang=js"

import "./LoadingBar.vue?vue&type=style&index=0&id=3ebc4b13&lang=css"

const __exports__ = script;

export default __exports__